// Per-device rate-limit identity (Lily 2026-09-03: store WiFi puts many
// customers behind one IP, so sendMagicLink throttles per device first).
// A random id persisted in this browser - self-reported, so the server
// keeps a wide per-IP ceiling as the spoof-proof backstop. Null when
// storage is unavailable (private mode): the server just skips the
// device layer then.
export const getDeviceId = () => {
  try {
    const KEY = 'luckyClawwDeviceId';
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};
